import VehicleIndex from "@/views/vehicle/VehicleIndex.vue";

const vehicle = [
    {
        path: '/vehicle',
        name: 'vehicle',
        component: VehicleIndex,
        meta: {
            requiresAuth: true,
            roles: ['Super Admin', 'Admin Office','Manager Driver'], 
        },
    }
]

export default vehicle;